import type { CrmRecordsRequestDto } from "app/pages/sales-intelligence/domain/crm-integration/types/records";

export const CRM_RECORDS_PAGE_SIZE = 3;

/**
 * Default first-page request for fetching a company's CRM records.
 *
 * `pageSize` is 3 because that is the most common number of CRM records a user has per company —
 * one page covers the typical case without an extra fetch, and larger sets paginate from here.
 */
export const CRM_RECORDS_DEFAULT_REQUEST: CrmRecordsRequestDto = {
    asc: false,
    page: 1,
    pageSize: CRM_RECORDS_PAGE_SIZE,
};